export function getFirstLettersOfFirstTwoWords(sentence: string): string {
    const words = sentence.split(' ');
    const firstTwoWords = words.slice(0, 2);
    return firstTwoWords.map(word => word.charAt(0)).join('');
}